import { Link } from "react-router-dom";
import { useDispatch } from "react-redux";
import { deleteItems } from "../../redux/actions/actionItem";


export default function ItemsCard({ id, idItem, name, stock, stockTotal, description }) {

  const dispatch = useDispatch();
  
  const handleDelete = async (e) => {
    dispatch(deleteItems(id))
    alert("elemento eliminado")
    window.location.reload()
   
  }
  return (
    <div className="border-b border-slate-500">
        <Link to={`/items/${id}`}>
      <div className="flex text-[11px] hover:font-bold pt-2 text-sky-200 hover:text-orange-400">
        <div className="border-slate-500 w-12">
          <p className="text-center">{idItem}</p>
        </div>
        <div className="border-slate-500 w-60">
          <p className="">{name}</p>
        </div>
        <div className="border-slate-500 w-6/12">
          <p className="">{description}</p>
        </div>
        <div className="border-slate-500 w-14 text-center">
          <p className="">{stock}</p>
        </div>
        <div className="border-slate-500 w-14 text-center">
          <p className="">{stockTotal}</p>
        </div>
        <div className="border-slate-500 w-14 text-center">
          <p className="">Res</p>
        </div>
        {/* <div>
          <button onClick={handleDelete}>
          Eliminar
          </button>          
        </div> */}
      </div>
        </Link>
    </div>
  );
}
